import { type CardTemplateId, isIssuedCard, matchesCardTemplate, selectedCards } from '@shared-core/features/backend'
import { useNavigation } from '@shared-core/navigation'
import { useAppSelector } from '@shared-core/store'
import { useState } from 'react'

export function useCardSelection(initialTemplateId: CardTemplateId) {
  const navigation = useNavigation()
  const cards = useAppSelector(selectedCards)
  const [selectedType, setSelectedType] = useState<CardTemplateId>(initialTemplateId)
  const selectCard = (type: CardTemplateId) => {
    if (type === selectedType) return
    setSelectedType(type)
    navigation.setParams({ selectedCardType: type })
  }
  const selectedCard = cards?.find((card) => isIssuedCard(card) && matchesCardTemplate(card, selectedType))
  return { selectedType, setSelectedType, selectCard, selectedCard }
}
